import { render, staticRenderFns } from "./GroupItem.vue?vue&type=template&id=0ccf2d87"
import script from "./GroupItem.vue?vue&type=script&lang=js"
export * from "./GroupItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports